<template>
    <section class="mt-56 dashboard-product-type">
        <h3 class="h3 cabinet-section__dashboard-title">Изделия</h3>
        <div v-if="loading">Loading...</div>

        <div
            v-else-if="!typesStats.length"
            class="d-flex flex-column flex-md-row align-items-center"
        >
            <img
                src="/img/icons/empty-goods.svg"
                class="dashboard-empty__img dashboard-empty__img--goods ofi"
            />
            <div
                class="dashboard-empty__descr dashboard-empty__descr--goods text-center text-md-left mt-4 mt-md-0"
            >
                <div class="dashboard-empty__title">
                    У вас пока что нет ни одного изделия.
                </div>
                Здесь вы увидите все типы ваших изделий и их количество.
                <div class="mt-16">
                    <router-link
                        :to="{ name: 'SupplierProductsAdd' }"
                        tag="button"
                        class="cabinet-btn  cabinet-btn--add cabinet-btn--add-white"
                        >Добавить изделие</router-link
                    >
                </div>
            </div>
        </div>

        <div v-else class="row dashboard-product-type__row">
            <div
                v-for="type in typesStats"
                :key="type.type_id"
                class="dashboard-product-type__card"
            >
                <router-link
                    :to="{
                        name: 'SupplierProducts',
                        params: { type_id: type.type_id }
                    }"
                    class="dashboard-product-type__content d-flex justify-content-between"
                >
                    {{ type.type_name }}
                    <span>{{ getFormattedNum(type.items_count) }}</span>
                </router-link>
            </div>
        </div>
    </section>
</template>

<script>
import getFormattedNum from '@/utils/getFormattedNum'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'ProductTypesStats',
    data() {
        return {
            loading: true
        }
    },
    computed: {
        ...mapState('supplierStats', ['typesStats'])
    },
    async mounted() {
        if (!this.typesStats.length) {
            await this.getTypesStats()
        }
        this.loading = false
    },
    methods: {
        ...mapActions('supplierStats', ['getTypesStats']),
        getFormattedNum(num) {
            return getFormattedNum(num)
        }
    }
}
</script>
